import request from '@/utils/request'

export function updateRandCardCfg(data) {
  return request({
    url: 'api/v1/rand-card/updateRandCardCfg',
    method: 'post',
    data: data
  })
}

export function getRandCardCfgList(data) {
  return request({
    url: 'api/v1/rand-card/getList',
    method: 'post',
    data: data
  })
}

export function getFirstCfg(data) {
  return request({
    url: 'api/v1/rand-card/getFirst',
    method: 'post',
    data: data
  })
}

export function delFirstCfg(data) {
  return request({
    url: 'api/v1/rand-card/delFirst',
    method: 'delete',
    data: data
  })
}

export function getSmallGameType() {
  return request({
    url: 'api/v1/rand-card/getSmallGameType',
    method: 'get'
  })
}

